"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgEditLocation(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "2 0 20 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M10 2c3.317 0 6 2.683 6 5.996C16 12.494 9.902 18 10 18c.098 0-6-5.506-6-10.004A5.994 5.994 0 0110 2zm1 4.268A2.001 2.001 0 008 8a2 2 0 103-1.732zm1.006 13.735v2.026h2.026l5.974-5.975-2.025-2.025-5.975 5.974zm9.914-6.567l-1.302-1.302a.509.509 0 00-.72 0l-1.196 1.157 2.041 2.041 1.177-1.176a.509.509 0 000-.72z", fillRule: "evenodd" })));
}
exports.default = tombacIcon_1.default('EditLocation')(SvgEditLocation);
//# sourceMappingURL=EditLocation.js.map